import React from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';
import SafePureComponent from '../shared/SafePureComponent';
import { isTriplePackage } from '../../reducers/packages';
import SinglePackage from './SinglePackage';
import TriplePackage from './TriplePackage';

import './style.scss';

const PackagesTabs = ({
    shouldRender = true,
    isTriplePackage,
    onComparePackagesClick,
    isInCustomOrderPackageTest,
    customOrder
}) => {

    if (!shouldRender) {return null;}

    const Component = isTriplePackage ? TriplePackage : SinglePackage;

    return (
        <Component onComparePackagesClick={onComparePackagesClick}
            isInCustomOrderPackageTest={isInCustomOrderPackageTest}
            customOrder={customOrder}/>
    );
};

PackagesTabs.propTypes = {
    shouldRender: bool,
    isTriplePackage: bool,
    isInCustomOrderPackageTest: bool,
    customOrder: object
};

const mapStateToProps = ({ packages }) => ({
    shouldRender: packages.packageList.length > 0,
    isTriplePackage: isTriplePackage(packages)
});

export { PackagesTabs };
export default SafePureComponent(connect(mapStateToProps)(PackagesTabs));
